import { IClient } from '../interface/IClient';
import { authenticatedApi } from './api';

const getAllClients = async () => {
  return authenticatedApi.get('client/all');
};

const getClient = async (clientId: number) => {
  return authenticatedApi.get(`client/${clientId}`);
};

const createClient = async (clientInput: IClient) => {
  return authenticatedApi.post('client/create', clientInput);
};

const updateClient = async (clientId: number, clientInput: IClient) => {
  return authenticatedApi.put(`client/update/${clientId}`, clientInput);
};

const deleteClient = async (clientId: number) => {
  return authenticatedApi.delete(`client/delete/${clientId}`);
};

const clientApi = { getAllClients, getClient, createClient, updateClient, deleteClient };

export default clientApi;
